export const PISGA = 'pisga'
export const GEVA = 'geva'
export const SHEFFEL = 'sheffel'
export const CONSTANT = 'constant'

export const NAME_RATE = [PISGA, SHEFFEL, GEVA, CONSTANT]
